import { Component } from '@angular/core';

@Component({
  selector: 'app-multiple-select-demo',
  templateUrl: './form-select-multiple-demo.component.html',
})
export class FormSelectMultipleDemoComponent {}
